import ClassenService from '../ClassenService';

class LanguageService {
  getLanguages() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/languages`);
  }

  addLanguage(languageData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/languages`, 'addLanguage', languageData);
  }

  getLanguage(languageId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/languages/${languageId}`);
  }

  updateLanguage(languageId, languageData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/languages/${languageId}`, 'updateLanguage', languageData);
  }

  deleteLanguage(languageId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/languages/${languageId}`, 'deleteLanguage');
  }

  activateLanguage({languageId}) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/languages/${languageId}/activate`, 'deleteLanguage');
  }
}

export default new LanguageService();
